import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import './styles/tokens.css'
import './styles/base.css'

import { router } from './app/routes.jsx'
import { AuthProvider } from './lib/auth.jsx'
import { ToastProvider } from './components/ui/Toast.jsx'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Server state, cached — but never so long that a stock figure on screen
      // is one a cashier would act on.
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      // retry: false on EVERY mutation (§11a). Retrying is the idempotency
      // layer's job; Query silently re-POSTing a committed sale is exactly
      // what the idempotency table exists to stop.
      retry: false,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </ToastProvider>
    </QueryClientProvider>
  </React.StrictMode>,
)
